import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { dueState, saveDue, buildDueIso } from "../TicketDue";

const BADGE = {
  done: ["Terminé", "bg-emerald-500 text-white"],
  overdue: ["En retard", "bg-red-600 text-white"],
  soon: ["Bientôt", "bg-amber-400 text-amber-950"],
  future: ["Compléter", "bg-norea-surfaceHover text-norea-text border border-norea-border"],
};
const pad = (n) => String(n).padStart(2, "0");
const dateOf = (iso) => { if (!iso) return ""; const d = new Date(iso); return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`; };
const timeOf = (iso) => { if (!iso) return ""; const d = new Date(iso); return `${pad(d.getHours())}:${pad(d.getMinutes())}`; };
const fmt = (iso, withTime) => new Date(iso).toLocaleString("fr-FR", withTime ? { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" } : { day: "numeric", month: "short" });

export function TicketDates({ ticket, basePath, onChange }) {
  const [open, setOpen] = useState(false);
  const [start, setStart] = useState(dateOf(ticket.start_at));
  const [due, setDue] = useState(dateOf(ticket.due_at));
  const [time, setTime] = useState(ticket.due_has_time ? timeOf(ticket.due_at) : "");
  const st = dueState(ticket);
  const save = async (body) => { if (await saveDue(basePath, ticket.id, body)) { onChange(); setOpen(false); } };
  const apply = () => save({ start_at: start ? new Date(`${start}T00:00:00`).toISOString() : null, due_at: buildDueIso(due, time), due_has_time: !!(due && time), due_done: !!ticket.due_done });
  const clear = () => { setStart(""); setDue(""); setTime(""); save({ start_at: null, due_at: null, due_has_time: false, due_done: !!ticket.due_done }); };
  const label = ticket.due_at
    ? `${ticket.start_at ? `${fmt(ticket.start_at, false)} - ` : ""}${fmt(ticket.due_at, ticket.due_has_time)}`
    : ticket.start_at ? `Début : ${fmt(ticket.start_at, false)}` : null;

  return (
    <div data-testid="trello-dates">
      <div className="text-xs font-semibold text-norea-textMuted mb-1.5">Dates</div>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md border border-norea-border bg-white hover:bg-norea-surfaceHover text-sm transition-colors" data-testid="trello-dates-btn">
            {label || <span className="text-norea-textMuted">Ajouter des dates</span>}
            {st && <span className={`text-[11px] font-semibold px-1.5 py-0.5 rounded ${BADGE[st][1]}`} data-testid="trello-dates-badge" data-state={st}>{BADGE[st][0]}</span>}
            <ChevronDown className="w-3.5 h-3.5 text-norea-textMuted" />
          </button>
        </PopoverTrigger>
        <PopoverContent align="start" className="w-72 p-3 space-y-3" data-testid="trello-dates-picker">
          <label className="block text-xs font-medium">Date de début (facultative)
            <input type="date" value={start} onChange={(e) => setStart(e.target.value)} className="input-field text-sm mt-1" data-testid="trello-start-date" />
          </label>
          <div>
            <div className="text-xs font-medium mb-1">Échéance</div>
            <div className="flex gap-2">
              <input type="date" value={due} onChange={(e) => setDue(e.target.value)} className="input-field text-sm flex-1" data-testid="trello-due-date" />
              <input type="time" value={time} disabled={!due} onChange={(e) => setTime(e.target.value)} className="input-field text-sm w-28" data-testid="trello-due-time" />
            </div>
          </div>
          <div className="flex gap-2 pt-1">
            <button onClick={apply} className="btn-primary text-xs flex-1 justify-center" data-testid="trello-dates-save">Enregistrer</button>
            <button onClick={clear} className="btn-secondary text-xs" data-testid="trello-dates-clear">Retirer</button>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}
